var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.15387H17.6154",
    stroke: "#767380",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07715 5.15387H15.5387V17.6154C15.5387 17.9826 15.3928 18.3348 15.1331 18.5945C14.8735 18.8541 14.5213 19 14.1541 19H4.46176C4.09454 19 3.74236 18.8541 3.48269 18.5945C3.22303 18.3348 3.07715 17.9826 3.07715 17.6154V5.15387Z",
    stroke: "#3A3940",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84619 5.15384V4.46153C5.84619 3.54348 6.21089 2.66302 6.86005 2.01386C7.50921 1.3647 8.38967 1 9.30773 1C10.2258 1 11.1062 1.3647 11.7554 2.01386C12.4046 2.66302 12.7693 3.54348 12.7693 4.46153V5.15384",
    stroke: "#3A3940",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23096 7.92303V15.5384",
    stroke: "#3A3940",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3848 7.92303V15.5384",
    stroke: "#3A3940",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.5c7b9075.svg";
export { ForwardRef as ReactComponent };